var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _path, _line15, _line16, _line17, _path2, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _path3, _line43, _line44, _path4, _line45, _line46, _path5, _line47, _path6, _line48, _line49, _path7, _line50, _path8, _line51, _line52, _line53, _line54, _line55, _path9, _line56, _line57, _line58, _line59, _path10, _line60, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTuckTopSnapLockBottomTemplate = function SvgTuckTopSnapLockBottomTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197.5mm",
    height: "172.0mm",
    viewBox: "-4.5 14.0 197.5 172.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 64,
    y2: 154,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 99,
    y1: 64,
    y2: 154,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 154,
    y1: 64,
    y2: 154,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    x2: 188,
    y1: 64,
    y2: 154,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10.5,
    y1: 64,
    y2: 65,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 10.5,
    y1: 70,
    y2: 65,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 10,
    y1: 153,
    y2: 154,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 10.5,
    y1: 148,
    y2: 153,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 10.5,
    y1: 65,
    y2: 153,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y1: 70,
    y2: 148,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 63,
    y2: 63,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 30,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 16.4,
    y1: 30,
    y2: 30,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 16.4,
    y1: 30,
    y2: 31,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 11.0 30 Q 11.0 19 23.4 19"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 30,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 58.6,
    x2: 65,
    y1: 30,
    y2: 30,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 58.6,
    x2: 58.6,
    y1: 30,
    y2: 31,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 64.0 30 Q 64.0 19 51.6 19"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 58.6,
    y1: 31,
    y2: 31,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 51.6,
    y1: 19,
    y2: 19,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 99,
    y1: 64,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 98,
    y1: 57.2,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    x2: 98,
    y1: 53.2,
    y2: 57.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 91.2,
    x2: 94,
    y1: 41,
    y2: 53.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    x2: 65,
    y1: 62,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 68.4,
    x2: 67,
    y1: 41,
    y2: 62,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 68.4,
    x2: 91.2,
    y1: 41,
    y2: 41,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 98,
    y1: 64,
    y2: 64,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 155,
    y1: 64,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 155,
    y1: 57.2,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 159,
    x2: 155,
    y1: 53.2,
    y2: 57.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 161.8,
    x2: 159,
    y1: 41,
    y2: 53.2,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    x2: 188,
    y1: 62,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 184.6,
    x2: 186,
    y1: 41,
    y2: 62,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 161.8,
    x2: 184.6,
    y1: 41,
    y2: 41,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 188,
    y1: 64,
    y2: 64,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 154,
    y1: 64,
    y2: 64,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 58,
    y2: 63,
    stroke: "blue",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 58,
    y2: 63,
    stroke: "blue",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 59,
    y2: 64,
    stroke: "blue",
    strokeDasharray: "10 10 2 5",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 188,
    y1: 154,
    y2: 154,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 23.80000000000001,
    y1: 154,
    y2: 171,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 23.80000000000001,
    x2: 23.80000000000001,
    y1: 171,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 23.80000000000001 176.0 Q 23.80000000000001 181.0 28.80000000000001 181.0"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 51.19999999999999,
    y1: 154,
    y2: 171,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 51.19999999999999,
    x2: 51.19999999999999,
    y1: 171,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 51.19999999999999 176.0 Q 51.19999999999999 181.0 46.19999999999999 181.0"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 28.80000000000001,
    x2: 46.19999999999999,
    y1: 181,
    y2: 181,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 99,
    y1: 154,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 99.0 176.0 Q 99.0 181.0 104.0 181.0"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    x2: 107.80000000000001,
    y1: 181,
    y2: 181,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 107.80000000000001 181.0 Q 112.80000000000001 181.0 112.80000000000001 176.0"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 112.80000000000001,
    x2: 112.80000000000001,
    y1: 171,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 154,
    y1: 154,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 149.0 181.0 Q 154.0 181.0 154.0 176.0"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 145.2,
    x2: 149,
    y1: 181,
    y2: 181,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 140.2 176.0 Q 140.2 181.0 145.2 181.0"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 140.2,
    x2: 140.2,
    y1: 171,
    y2: 176,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 112.80000000000001,
    x2: 140.2,
    y1: 171,
    y2: 171,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 154,
    y2: 177.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    x2: 99,
    y1: 167.8,
    y2: 154,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    x2: 84,
    y1: 167.8,
    y2: 172.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 79.0 177.8 Q 84.0 177.8 84.0 172.8"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 79,
    y1: 177.8,
    y2: 177.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    x2: 188,
    y1: 154,
    y2: 177.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 171,
    y1: 154,
    y2: 167.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    x2: 171,
    y1: 172.8,
    y2: 167.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 174.0 177.8 Q 169.0 177.8 169.0 172.8"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 174,
    x2: 188,
    y1: 177.8,
    y2: 177.8,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "height",
    fill: "#000",
    stroke: "#000",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 103.91734,
    y1: 63.945824,
    y2: 153.94597,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 63.945824,
    y2: 67.945824,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 63.945824,
    y2: 67.945824,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 153.94597,
    y2: 149.94597,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 153.94597,
    y2: 149.94597,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -110.94587,
    y: 108.91743,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Height ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    fill: "#000",
    stroke: "#000",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 99,
    y1: 88.050018,
    y2: 88.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 82.766663,
    y: 86.050018,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Depth ")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "width",
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 88.108353,
    y2: 88.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.208328,
    y: 86.108353,
    strokeWidth: 0.1,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444447px"
  }, " Width ")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTuckTopSnapLockBottomTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tuck-top-snap-lock-bottom-template.4e92dfe4.svg";
export { ForwardRef as ReactComponent };